import React, { useCallback, useState } from 'react';
import numeral from 'numeral';
import _ from 'lodash';
import { Col, Row } from 'reactstrap';
import {
  CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements,
} from '@stripe/react-stripe-js';

import {
  ModalForm, Intl, FormActionsBtns, ConfirmationModal,
} from 'components';
import { required } from 'config/InputErrors';
import { currencyFormat } from 'utils';
import stripeLog from 'assets/img/stripe.svg';
import PaymentField from '../PaymentField';
import { useSelector } from 'react-redux';

export default ({
  paymentData, open, onSubmit, onSuccessPayment, onClose,
}) => {
  const userData = useSelector(state => state.user);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [show, setShow] = useState(true);
  const stripe = useStripe();
  const elements = useElements();

  const toggleConfirmationModal = useCallback(() => {
    setShow((show) => !show);
    setConfirmationModal((state) => !state);
  }, []);

  const submitForm = useCallback(async () => {
    if (!stripe || !elements) return;

    let amount = paymentData.total;
    if (_.indexOf(amount, ',') !== -1) {
      amount = amount.split(',').join('');
    }
    if (_.indexOf(amount, '.') !== -1) {
      amount = amount.split('.').join('');
    }

    let { iva } = paymentData;
    if (_.indexOf(iva, ',') !== -1) {
      iva = iva.split(',').join('');
    }
    if (_.indexOf(iva, '.') !== -1) {
      iva = iva.split('.').join('');
    }

    return onSubmit({ total: amount, iva }, stripe, elements, () => {
      toggleConfirmationModal();
    });
  }, [paymentData, elements, stripe, onSubmit, toggleConfirmationModal]);

  return (
    <>
      {show ?
        <ModalForm
          showErrorsInHeader
          title="enterCardInformation"
          open={open}
          size="md"
          onClose={onClose}
          onSubmit={submitForm}
          footer={(
            <FormActionsBtns
              translateSaveBtn={false}
              saveLabel={(
                <Intl
                  id="payAmount"
                  values={{ amount: numeral(paymentData.total).format(currencyFormat(userData.currency_symbol)) }}
                />
              )}
              onClickCancel={onClose}
            />
          )}
          bodyClassName="stripe-card-form"
          body={() => (
            <>
              <Row className="mt-4">
                <Col>
                  <img src={stripeLog} alt="Stripe" />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={12}>
                  <PaymentField
                    field="cardNumber"
                    showIcon
                    validate={required}
                    Element={CardNumberElement}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <PaymentField
                    field="cardExpire"
                    validate={required}
                    Element={CardExpiryElement}
                  />
                </Col>
                <Col md={3} className="pl-md-0">
                  <PaymentField
                    field="cardCvc"
                    validate={required}
                    Element={CardCvcElement}
                  />
                </Col>
              </Row>
            </>
          )}
        /> : null}
      {confirmationModal
        && (
          <ConfirmationModal
            title="paymentSuccessful"
            open={confirmationModal}
            confirmClose
            onConfirm={onSuccessPayment}
          />
        )}
    </>
  );
};
